import React from "react";
import { SERVICES } from "@/lib/constants";

export const ServiceSelector = ({ value, onChange }) => (
  <div className="grid gap-3">
    {SERVICES.map((s) => {
      const Icon = s.icon;
      const active = value === s.key;
      return (
        <button
          key={s.key}
          type="button"
          data-testid={`service-${s.key.toLowerCase()}-btn`}
          onClick={() => onChange(s.key)}
          className={`group flex items-center gap-4 rounded-2xl border p-4 text-left transition-all duration-200 ${
            active
              ? "border-[#ff6a00] bg-[#ff6a00]/10 shadow-[0_0_24px_rgba(255,106,0,0.18)]"
              : "border-[#1F293D] bg-[#151b2b] hover:border-[#ff6a00]/40 hover:bg-[#1c2334]"
          }`}
        >
          <div
            className={`flex h-12 w-12 shrink-0 items-center justify-center rounded-xl transition-colors ${
              active ? "bg-[#ff6a00] text-white" : "bg-[#1c2334] text-[#ff6a00]"
            }`}
          >
            <Icon className="h-6 w-6" strokeWidth={2.2} />
          </div>
          <div className="min-w-0 flex-1">
            <div className="font-display text-base font-bold tracking-tight text-white">{s.title}</div>
            <div className="text-xs text-slate-400">{s.subtitle}</div>
          </div>
          <div className="text-right">
            <div className="text-[10px] uppercase tracking-wide text-slate-500">dès</div>
            <div className="font-mono text-lg font-bold text-[#ff6a00]">{s.base}€</div>
          </div>
        </button>
      );
    })}
  </div>
);
